import React, { useEffect, useState } from 'react';
import { fetchPersonas } from '../../services/General/personaService';
import { Persona } from '../../types/persona';


interface PersonaSearchProps {
    onPersonaSelect?: (persona: Persona) => void; // Callback para manejar la selección del usuario
    value?: string;
}

// Frontend: Componente de búsqueda
const PersonaSearch = ({ onPersonaSelect, value = '' }: PersonaSearchProps) => {
    const [query, setQuery] = useState('');
    const [personas, setPersonas] = useState<Persona[]>([]);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setQuery(value);
    }, [value])

    const searchPersonas = async (cedula: string) => {
        setLoading(true);
        if (cedula.length < 6) {
            setPersonas([]);
            return;
        }

        const personasResponse = await fetchPersonas(cedula);
        setPersonas(personasResponse);
        setLoading(false);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setQuery(newValue);
        searchPersonas(newValue);
    }

    const handlePersonaSelectInternal = (persona: Persona) => {
        onPersonaSelect?.(persona);
        setQuery(persona.CEDULA);
    }

    return (
        <div className="position-relatve">
            {/* <label htmlFor="personaSearch" className="form-label me-2">Buscar Persona: </label> */}
            <input
                type="text"
                className='form-control form-control-sm mb-3'
                placeholder='Buscar por cédula...'
                id='personaSearch'
                autoComplete='off'
                value={query}
                onChange={handleInputChange}
                onFocus={() => setIsOpen(true)}
                onBlur={() => setTimeout(() => setIsOpen(false), 200)}
                style={{ width: '100%' }}
            />
            {isOpen && (
                <div className="dropdown-menu show w-100 overflow-auto" style={{ maxHeight: '300px', maxWidth: '600px' }}>
                    <ul className="list-group" style={{ maxHeight: '250px', width: '600px' }}>
                        {loading && (
                            <div className="dropdown-item text-muted text-center">
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Buscando...
                            </div>
                        )}
                        {personas.length > 0 ? (
                            personas.map((persona: Persona, index: number) => (
                                <button
                                    type='button'
                                    key={index}
                                    className='dropdown-item text-start small'
                                    style={{ cursor: 'pointer' }}
                                    onMouseDown={() => handlePersonaSelectInternal(persona)}
                                >
                                    {persona.CEDULA} - {persona.NOMBRE}
                                </button>
                            ))
                        ) : (
                            <li className="list-group-item">No se encontraron resultados</li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default PersonaSearch;